// import css
import "./assets/index.css";
// import global components
import Header from "./components/global/header";
import HeaderMobile from "./components/global/header-mobile";
import HeaderMegaMenu from "./components/blocks/mega-menu-desktop";
import ScrollToHash from "./components/global/scroll-to-hash";
import initBackgroundStack from "./components/global/background-stack";
// init globals
Header();
HeaderMobile();
HeaderMegaMenu();
ScrollToHash();
initBackgroundStack();
// import page components
import StickyScrollNav from "./components/blocks/sticky-scroll-nav";
import StickySidebarNav from "./components/blocks/sticky-sidebar-nav";
import HeroVideo from "./components/blocks/hero-video";
import VideoPlayer from "./components/blocks/video-player";
import SwiperCarousel from "./components/blocks/swiper-carousel";
import QuoteBlockSwiperCarousel from "./components/blocks/quote-block-swiper-carousel";
import ExtendedSearchFeatured from "./components/blocks/extended-search-featured";
import AccordionItem from "./components/blocks/accordion-item";
import ShareButtons from "./components/blocks/share-buttons";
import SolutionsGrid from "./components/blocks/solutions-grid";
import SwiperTabsCarousel from "./components/blocks/swiper-tabs-carousel";
import SwiperHeroCarousel from "./components/blocks/swiper-hero-carousel";
import HorizontalStickySubnav from "./components/blocks/horizontal-sticky-subnav";
import HorizontalStickySubnavCarousel from "./components/blocks/horizontal-sticky-subnav-carousel";
import LogoCarousel from "./components/blocks/logo-carousel";
import FilterPage from "./components/pages/FilterPage";
import StartPage from "./components/pages/StartPage";
// init page components
StickyScrollNav();
StickySidebarNav();
HeroVideo();
VideoPlayer();
SwiperCarousel();
QuoteBlockSwiperCarousel();
ExtendedSearchFeatured();
AccordionItem();
ShareButtons();
SolutionsGrid();
SwiperTabsCarousel();
SwiperHeroCarousel();
HorizontalStickySubnav();
HorizontalStickySubnavCarousel();
LogoCarousel();
//Import Pages
FilterPage();
StartPage();
